import React, { useState } from "react";

/**
 * Dashboard banner: this term needs a last day, and the next term needs a first day.
 * Hidden entirely when the caller decides the org is cancelled.
 */
export default function TermNextBanner({
  currentTermStart,
  onSave,
}: {
  currentTermStart?: string | null;
  onSave: (thisTermEnd: string, nextTermStart: string) => Promise<void>;
}): JSX.Element {
  const [thisEnd, setThisEnd] = useState("");
  const [nextStart, setNextStart] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const canSave =
    /^\d{4}-\d{2}-\d{2}$/.test(thisEnd) &&
    /^\d{4}-\d{2}-\d{2}$/.test(nextStart) &&
    nextStart > thisEnd &&
    (!currentTermStart || thisEnd >= currentTermStart);

  return (
    <div className="px-6 pt-4">
      <div
        style={{
          borderRadius: 14,
          border: "1px solid #ddd6fe",
          background: "#f5f3ff",
          padding: "14px 16px",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 800, color: "#1B1533", marginBottom: 4 }}>
          This term is ending — two dates
        </div>
        <p style={{ margin: "0 0 12px", fontSize: 13, lineHeight: 1.5, color: "#5A5470" }}>
          The last day children come this term, and the first day they come back next term.
          Charts stay on this term until that return day. Billing still follows the months
          you painted at signup.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "flex-end" }}>
          <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 11, fontWeight: 700, color: "#5A5470" }}>
            Last day of this term
            <input
              type="date"
              value={thisEnd}
              onChange={(e) => setThisEnd(e.target.value)}
              min={currentTermStart || undefined}
              style={{
                fontFamily: "inherit",
                fontSize: 14,
                padding: "8px 10px",
                borderRadius: 10,
                border: "1.5px solid #DED8EE",
                background: "#fff",
              }}
            />
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 11, fontWeight: 700, color: "#5A5470" }}>
            First day of next term
            <input
              type="date"
              value={nextStart}
              onChange={(e) => setNextStart(e.target.value)}
              min={thisEnd || undefined}
              style={{
                fontFamily: "inherit",
                fontSize: 14,
                padding: "8px 10px",
                borderRadius: 10,
                border: "1.5px solid #DED8EE",
                background: "#fff",
              }}
            />
          </label>
          <button
            type="button"
            disabled={!canSave || busy}
            onClick={async () => {
              if (!canSave) return;
              setBusy(true);
              setErr(null);
              try {
                await onSave(thisEnd, nextStart);
              } catch (e) {
                setErr(e instanceof Error ? e.message : "Could not save.");
              } finally {
                setBusy(false);
              }
            }}
            style={{
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 700,
              padding: "9px 14px",
              borderRadius: 10,
              border: "none",
              background: canSave && !busy ? "linear-gradient(135deg, #9B7CFF, #6F4FF0)" : "#E9E5F3",
              color: canSave && !busy ? "#fff" : "#8E86A8",
              cursor: canSave && !busy ? "pointer" : "not-allowed",
            }}
          >
            {busy ? "Saving…" : "Save term dates"}
          </button>
        </div>
        {err ? <div style={{ marginTop: 8, fontSize: 12, color: "#c2453f" }}>{err}</div> : null}
      </div>
    </div>
  );
}
